var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isPaid
    ? _c("cart-template", {
        attrs: { canBack: false },
        scopedSlots: _vm._u(
          [
            {
              key: "configuration",
              fn: function() {
                return [
                  _c(
                    "el-form",
                    {
                      ref: "clientCartForm",
                      attrs: {
                        "label-position": "top",
                        rules: _vm.rules,
                        model: _vm.modelForm
                      }
                    },
                    [_c("public-payment-cart")],
                    1
                  )
                ]
              },
              proxy: true
            },
            {
              key: "resume",
              fn: function() {
                return [
                  _c("cart-summary", {
                    attrs: { context: "client" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "licences",
                          fn: function() {
                            return [
                              _c(
                                "ul",
                                { staticClass: "cart-licences-list mb-0 mx-0" },
                                [
                                  _vm._l(_vm.productsWithLicences, function(
                                    product
                                  ) {
                                    return _c(
                                      "li",
                                      {
                                        key: product.code,
                                        staticClass: "flex-row"
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "grey mb-0 mt-0 fs-3"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$l10n.n__(
                                                      "%(total)s licence %(productsName)s",
                                                      "%(total)s licences %(productsName)s",
                                                      _vm.products[product.id]
                                                        .quantity,
                                                      {
                                                        total:
                                                          _vm.products[
                                                            product.id
                                                          ].quantity,
                                                        productsName:
                                                          product.title
                                                      }
                                                    )
                                                  ) +
                                                  "\n                            "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.freeLicencesByProduct(product.id)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "grey mt-1 block"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$l10n.n__(
                                                        "Dont %s offerte",
                                                        "Dont %s offertes",
                                                        _vm.freeLicencesByProduct(
                                                          product.id
                                                        ),
                                                        _vm.freeLicencesByProduct(
                                                          product.id
                                                        )
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _vm.products[product.id].total
                                          ? [
                                              _vm.freeLicencesByProduct(
                                                product.id
                                              )
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "flex-item-right my-0"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "strike grey"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$filters.numberFormatToFloatWithOptions(
                                                                _vm.products[
                                                                  product.id
                                                                ].total.monthly
                                                                  .total_amount,
                                                                _vm.numformat,
                                                                true
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "success-50 fs-3 pl-2 semibold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$filters.numberFormatToFloatWithOptions(
                                                                _vm.products[
                                                                  product.id
                                                                ].total.monthly
                                                                  .total_amount_discounted,
                                                                _vm.numformat,
                                                                true
                                                              )
                                                            ) +
                                                              _vm._s(
                                                                _vm.$l10n.__(
                                                                  "/mois"
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "flex-item-right my-0 fs-3 semibold grey"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                " +
                                                          _vm._s(
                                                            _vm.$filters.numberFormatToFloatWithOptions(
                                                              _vm.products[
                                                                product.id
                                                              ].total.monthly
                                                                .total_amount_discounted,
                                                              _vm.numformat,
                                                              true
                                                            )
                                                          ) +
                                                          _vm._s(
                                                            _vm.$l10n.__(
                                                              "/mois"
                                                            )
                                                          ) +
                                                          "\n                            "
                                                      )
                                                    ]
                                                  )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.packsWithLicences, function(
                                    product
                                  ) {
                                    return _c(
                                      "li",
                                      {
                                        key: product.code,
                                        staticClass: "flex-row"
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "grey mb-1 mt-0 fs-3"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$l10n.__(
                                                      "Module %(productsName)s",
                                                      {
                                                        productsName:
                                                          product.title
                                                      }
                                                    )
                                                  ) +
                                                  "\n                            "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.products[product.id].total
                                          ? [
                                              _vm.products[product.id].total
                                                .monthly
                                                .total_amount_discounted <
                                              _vm.products[product.id].total
                                                .monthly.total_amount
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "flex-item-right my-0 semibold"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "strike grey"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$filters.numberFormatToFloatWithOptions(
                                                                _vm.products[
                                                                  product.id
                                                                ].total.monthly
                                                                  .total_amount,
                                                                _vm.numformat,
                                                                true
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "success-50 fs-3 pl-2"
                                                        },
                                                        [
                                                          _vm.products[
                                                            product.id
                                                          ].total.monthly
                                                            .total_amount_discounted !==
                                                          0
                                                            ? [
                                                                _vm._v(
                                                                  "\n                                        " +
                                                                    _vm._s(
                                                                      _vm.$filters.numberFormatToFloatWithOptions(
                                                                        _vm
                                                                          .products[
                                                                          product
                                                                            .id
                                                                        ].total
                                                                          .monthly
                                                                          .total_amount_discounted,
                                                                        _vm.numformat,
                                                                        true
                                                                      )
                                                                    ) +
                                                                    _vm._s(
                                                                      _vm.$l10n.__(
                                                                        "/mois"
                                                                      )
                                                                    ) +
                                                                    "\n                                    "
                                                                )
                                                              ]
                                                            : [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$l10n.__(
                                                                      "Offert"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "flex-item-right my-0 fs-3 semibold grey"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                " +
                                                          _vm._s(
                                                            _vm.$filters.numberFormatToFloatWithOptions(
                                                              _vm.products[
                                                                product.id
                                                              ].total.monthly
                                                                .total_amount_discounted,
                                                              _vm.numformat,
                                                              true
                                                            )
                                                          ) +
                                                          _vm._s(
                                                            _vm.$l10n.__(
                                                              "/mois"
                                                            )
                                                          ) +
                                                          "\n                            "
                                                      )
                                                    ]
                                                  )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "subtotal",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-column fs-3 cart-recap-total-label"
                                },
                                [
                                  _c("span", { staticClass: "mb-3" }, [
                                    _vm._v(_vm._s(_vm.$l10n.__("Sous-total")))
                                  ]),
                                  _vm._v(" "),
                                  _vm.taxRate && _vm.taxRate !== 0
                                    ? _c("span", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          _vm._s(_vm.$l10n.__("TVA")) +
                                            " " +
                                            _vm._s(_vm.taxRate) +
                                            "%"
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isYearly
                                ? _c(
                                    "div",
                                    { staticClass: "flex-column aright fs-3" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "semibold mb-3" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$filters.numberFormatToFloatWithOptions(
                                                _vm.totalYearly
                                                  .total_amount_discounted,
                                                _vm.numformat,
                                                true
                                              )
                                            ) + _vm._s(_vm.$l10n.__("/an"))
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.taxRate && _vm.taxRate !== 0
                                        ? _c(
                                            "span",
                                            { staticClass: "semibold mb-3" },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$filters.numberFormatToFloatWithOptions(
                                                      _vm.totalYearly
                                                        .total_amount_vat,
                                                      _vm.numformat,
                                                      true
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isMonthly
                                ? _c(
                                    "div",
                                    { staticClass: "flex-column aright fs-3" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "semibold mb-3" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$filters.numberFormatToFloatWithOptions(
                                                _vm.totalMonthly
                                                  .total_amount_discounted,
                                                _vm.numformat,
                                                true
                                              )
                                            ) + _vm._s(_vm.$l10n.__("/mois"))
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.taxRate && _vm.taxRate !== 0
                                        ? _c(
                                            "span",
                                            { staticClass: "semibold mb-3" },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$filters.numberFormatToFloatWithOptions(
                                                      _vm.totalMonthly
                                                        .total_amount_vat,
                                                      _vm.numformat,
                                                      true
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "total",
                          fn: function() {
                            return [
                              _c("div", { staticClass: "flex-row jc-space" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "fs-4 my-0 bold cart-recap-total-label"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.$l10n.__("Total TTC")) +
                                        "\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isYearly
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "fs-4 my-0 aright bold flex-row baseline"
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$filters.numberFormatToFloatWithOptions(
                                                _vm.totalYearly
                                                  .total_amount_tax_included,
                                                _vm.numformat,
                                                true
                                              )
                                            ) +
                                            "\n                        "
                                        ),
                                        _c("span", { staticClass: "fs-2" }, [
                                          _vm._v(_vm._s(_vm.$l10n.__("/an")))
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isMonthly
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "fs-4 my-0 aright bold flex-row baseline"
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$filters.numberFormatToFloatWithOptions(
                                                _vm.totalMonthly
                                                  .total_amount_tax_included,
                                                _vm.numformat,
                                                true
                                              )
                                            ) +
                                            "\n                        "
                                        ),
                                        _c("span", { staticClass: "fs-2" }, [
                                          _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "actions",
                          fn: function() {
                            return [
                              _c("CompassButton", {
                                staticClass: "wp-10 mt-4",
                                attrs: {
                                  label: _vm.labelButton,
                                  type: "primary",
                                  leftIcon: "lock-fill",
                                  loading: _vm.computeLoading
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.submitForm(
                                      "clientCartForm",
                                      "create"
                                    )
                                  }
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2700962964
                    )
                  })
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          3463973309
        )
      })
    : _c("payment-confirmed", { attrs: { isConnected: false } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }